module.exports = __webpack_public_path__ + "img/frame (102).0a8ca56a.jpg";